import React from "react";
import { Image, Button, Collapse } from "antd";

import Classes from "./index.module.css";
import { GetSerialProgram } from "../../util/sessionManager";

const Panel = Collapse.Panel;

const ProductItem = ({
  product,
  priviliges,
  image = true,
  btn,
}) => {
  const {
    thumb,
    name,
    id,
    price1,
    price2,
    price3,
    price4,
    price5,
    content,
    qty,
  } = product;
  const {
    btnTitle,
    btnAction
  } = btn
  const pic = thumb
    ? "http://sabaapi.com/android_project/visitor/uploads_pic/" +
      GetSerialProgram() +
      "/" +
      thumb +
      ".jpg"
    : "http://sabaapi.com/webapi/visitor/frontEnd/box.png";
  return (
    <div
      className={`gx-product-item gx-product-vertical ${Classes.gxproducttitle}`}
    >
      <div className={Classes.title}>
        <span className={"gx-product-title"}>
          <small className="gx-text-grey">{id + "- "}</small>
          {name}
        </span>
      </div>
      {image && (
        <div className="gx-product-image">
          <div className="gx-grid-thumb-equal">
            <span className={`gx-link gx-grid-thumb-cover ${Classes.picture}`}>
              <Image.PreviewGroup items={[pic]}>
                <Image alt={name} src={pic} />
              </Image.PreviewGroup>
            </span>
          </div>
        </div>
      )}

      <div className={`gx-product-body ${Classes.productTitle}`}>
        <table className={Classes.bodyTable1}>
          <tbody>
            <tr>
              {priviliges["content"]
                ? [
                    <td colSpan={1} className={Classes.centerText}>
                      محتوا:
                    </td>,
                    <td className={Classes.rightText}>{content}</td>,
                  ]
                : ""}
              {priviliges["pac"]
                ? [
                    <td colSpan={1} className={Classes.centerText}>
                      بسته:
                    </td>,
                    <td className={Classes.rightText}>
                      {parseInt(qty / content)}
                    </td>,
                  ]
                : ""}
              {priviliges["pac2"]
                ? [
                    <td colSpan={1} className={Classes.centerText}>
                      جز:
                    </td>,
                    <td className={Classes.rightText}>{qty % content}</td>,
                  ]
                : ""}
              {priviliges["count"]
                ? [
                    <td colSpan={1} className={Classes.centerText}>
                      تعداد:
                    </td>,
                    <td className={Classes.rightText}>{qty}</td>,
                  ]
                : ""}
            </tr>
          </tbody>
        </table>

        <table className={Classes.bodyTable}>
          <tbody>
            <tr>
              {priviliges["fee1"]
                ? [<td colSpan={2}>فی فروش1:</td>, <td>{price1}</td>]
                : ""}
            </tr>
            <tr>
              {priviliges["fee2"]
                ? [<td colSpan={2}>فی فروش2:</td>, <td>{price2}</td>]
                : ""}
            </tr>
            <tr>
              {priviliges["fee3"]
                ? [<td colSpan={2}>فی فروش3:</td>, <td>{price3}</td>]
                : ""}
            </tr>
            <tr>
              {priviliges["fee4"]
                ? [<td colSpan={2}>فی فروش4:</td>, <td>{price4}</td>]
                : ""}
            </tr>
            <tr>
              {priviliges["price5"]
                ? [<td colSpan={2}>فی فروش5:</td>, <td>{price5}</td>]
                : ""}
            </tr>
          </tbody>
        </table>

        {btnTitle.length>0 ? (
          <Button
            type="primary"
            className={Classes.btn}
            onClick={() => {
              btnAction(id, name, qty / content, qty % content);
            }}
          >
            {btnTitle}
          </Button>
        ):""}
      </div>
    </div>
  );
};

export default ProductItem;
